import { DefaultProjectTeamMaintenanceViewBase } from './base/default-project-team-maintenance-view-base';

export class DefaultProjectTeamMaintenanceView extends DefaultProjectTeamMaintenanceViewBase { }